import { render, staticRenderFns } from "./TemplateEditorPage.vue?vue&type=template&id=a4903e6e&scoped=true&"
import script from "./TemplateEditorPage.vue?vue&type=script&lang=js&"
export * from "./TemplateEditorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4903e6e",
  null
  
)

export default component.exports